export enum API_STATUS_CODE {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  SERVER_ERROR = 500,
  NOT_FOUND = 404,
}
